import { render, staticRenderFns } from "./span-time.vue?vue&type=template&id=391f5a2e"
import script from "./span-time.vue?vue&type=script&lang=js"
export * from "./span-time.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports